import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';
import { TokenInterceptor } from './auth/login/authentication/TokenInterceptor';
import { SharedModule } from "./shared/shared.module";
import { provideFlatpickrDefaults } from 'angularx-flatpickr';

// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToastaConfig, ToastaModule, ToastaService } from 'ngx-toasta';
import { AuthGuardService } from './auth/login/authentication/guards/auth.guards';
import { MessageService } from './utils/services/message.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { UsuarioModule } from './usuario/usuario.module';
import { PermissaoRecursoGuard } from './utils/permissoes/permissao-recurso.guards';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    //     // for HttpClient use:
    LoadingBarHttpClientModule,
    //     // for Router use:
    LoadingBarRouterModule,
    //     // for Core use:
    LoadingBarModule,
    NgxPermissionsModule.forRoot(),
    ToastaModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgSelectModule,
    UsuarioModule,
  ],
  providers: [
    CookieService,
    AuthGuardService,
    AppService,
    TokenInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    MessageService,
    ToastaService,
    ToastaConfig,
    provideNgxMask(),
    PermissaoRecursoGuard,
    provideFlatpickrDefaults(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
